"use client";

import { useState } from "react";
import { Check } from "lucide-react";

export function HeroQuickSubscribe() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || status === "loading") return;

    setStatus("loading");
    try {
      const res = await fetch("/api/newsletter/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source: "hero-quick" }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus("success");
      }
    } catch {
      // ignore
    } finally {
      if (status !== "success") setStatus("idle");
    }
  };

  if (status === "success") {
    return (
      <div className="py-3 text-center">
        <p className="text-emerald-400 text-sm font-medium flex items-center justify-center gap-2">
          <Check className="w-5 h-5" />
          Thanks! Check your inbox for the free report.
        </p>
      </div>
    );
  }

  return (
    <>
      <p className="text-sm text-emerald-200/70 mb-3">
        Get the free Middle East EV Aftermarket Report — 30+ pages of market data
      </p>
      <form className="flex flex-col sm:flex-row gap-3" onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your work email"
          required
          className="flex-1 h-11 px-4 rounded-xl bg-slate-900/80 border border-emerald-500/30 text-white placeholder:text-emerald-300/40 text-sm focus:outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-500/20 transition-all"
          disabled={status === "loading"}
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-11 px-6 rounded-xl bg-gradient-to-r from-emerald-500 to-cyan-400 text-sm font-semibold text-slate-900 hover:from-emerald-400 hover:to-cyan-300 shadow-lg shadow-emerald-500/30 transition-all duration-300 hover:shadow-emerald-400/50 whitespace-nowrap disabled:opacity-70"
        >
          {status === "loading" ? "Sending..." : "Get Free Report"}
        </button>
      </form>
    </>
  );
}
